import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  TextField,
  Button,
  Autocomplete,
  DialogContent,
  Dialog,
} from "@mui/material";
import { UseMotorDelivery } from "./UseMotorDelivery";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AssignDriver(props) {
  const { AssignToDriver, GetAllDrivers, GetDriverHive } = UseMotorDelivery();
  const [showText, setShowText] = useState("");
  const [drivers, setDrivers] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialog, setOpenDilog] = useState(false);
  const [orderIDForHive, setOrderIDForHive] = useState("");
  const [hiveDetails, setHiveDetails] = useState();
  const orderCTF = useRef(null);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.orderModel && props.orderModel.orderID) {
      setShowText(props.orderModel.orderID);
    } else if (props.orderModel && props.orderModel.zoneIndex) {
      setShowText(props.orderModel.zoneIndex);
    } else {
      setShowText();
    }
  }, [props.orderModel]);

  useEffect(() => {
    GetAllDrivers((drivers) => {
      let newDrivers = drivers.map((m) => {
        m.id = m.id + 1;
        return m;
      });
      setDrivers(newDrivers);
    });
  }, [props.filters]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isSmall ? "column" : "row",
        alignItems: isSmall ? "flex-start" : "center",
        justifyContent: "space-between",
        gap: 2,
        mt: 1,
        width: "100%",
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setOrderIDForHive("");
          setHiveDetails();
          setOpenDilog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              width: "100%",
            }}
          >
            <TextField
              inputRef={orderCTF}
              label="سفارش"
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              value={orderIDForHive ? orderIDForHive : ""}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setOrderIDForHive(evt.target.value);
              }}
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  let hiveModel = {
                    orderID: Number(orderIDForHive),
                    deliveryDate: props.filters.deliveryDate,
                    deliveryPart: props.filters.deliveryPart,
                  };
                  GetDriverHive(hiveModel, (callback) => {
                    if (callback) {
                      setOrderIDForHive();
                      orderCTF.current.focus();
                      setHiveDetails(callback);
                    } else {
                      orderCTF.current.select();
                      // setOrderIDForHive("");
                      setHiveDetails("");
                    }
                  });
                }
              }}
            />
            <Button
              variant="contained"
              onClick={() => {
                let hiveModel = {
                  orderID: Number(orderIDForHive),
                  deliveryDate: props.filters.deliveryDate,
                  deliveryPart: props.filters.deliveryPart,
                };
                GetDriverHive(hiveModel, (callback) => {
                  if (callback) {
                    setOrderIDForHive();
                    orderCTF.current.focus();
                    setHiveDetails(callback);
                  } else {
                    orderCTF.current.select();
                    // setOrderIDForHive("");
                    setHiveDetails("");
                  }
                });
              }}
            >
              جستجو
            </Button>
            {!hiveDetails ? (
              <Button
                variant="outlined"
                onClick={() => {
                  setOrderIDForHive("");
                  setHiveDetails();
                  setOpenDilog(false);
                }}
              >
                انصراف
              </Button>
            ) : (
              ""
            )}
          </Box>
          {hiveDetails ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "center",
              }}
            >
              <TextField
                sx={{
                  input: {
                    textAlign: "center",
                  },
                  width: "25%",
                }}
                label="سفارش"
                value={hiveDetails ? hiveDetails.orderID : ""}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
              />
              <TextField
                sx={
                  {
                    // width: "15%",
                  }
                }
                label="راننده"
                value={hiveDetails ? hiveDetails.driver : ""}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
              />
              <TextField
                sx={{
                  width: "25%",
                  input: {
                    textAlign: "center",
                  },
                }}
                label="هایو"
                value={hiveDetails ? hiveDetails.hiveNO : ""}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
              />
            </Box>
          ) : (
            ""
          )}
          {hiveDetails ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "center",
              }}
            >
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setOrderIDForHive("");
                  setHiveDetails();
                  setOpenDilog(false);
                }}
              >
                بستن
              </Button>
            </Box>
          ) : (
            ""
          )}
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          alignItems: isSmall ? "flex-start" : "center",
          gap: 2,
          width: "100%",
          // height: "10%",
        }}
      >
        <Typography variant="subtitle2">اختصاص سفارش / روت </Typography>
        <TextField
          sx={{
            width: isSmall ? "100%" : "15%",
            input: {
              textAlign: "center",
            },
          }}
          value={showText ? showText : ""}
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
        {drivers && (
          <Autocomplete
            size="small"
            // value={props.assignModel.driverID ? props.assignModel.driverID : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                props.setAssignModel({
                  ...props.assignModel,
                  driverID: newValue - 1,
                });
              } else {
                props.setAssignModel({
                  ...props.assignModel,
                  driverID: undefined,
                });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return drivers?.find((m) => m.id == option)?.driver;
              }
              return "";
            }}
            sx={{ width: isSmall ? "100%" : "20%" }}
            options={drivers?.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                //   error={errorState.id}
                variant="outlined"
                {...params}
                label="راکب"
              />
            )}
          />
        )}
        <Button
          sx={{ width: "80px" }}
          variant="contained"
          onClick={() => {
            let model = {
              deliveryDate: props.filters.deliveryDate,
              deliveryPart: props.filters.deliveryPart,
              orderID: props.assignModel.orderID
                ? props.assignModel.orderID
                : undefined,
              zoneIndex: props.assignModel.zoneIndex
                ? props.assignModel.zoneIndex
                : undefined,
              driverID:
                props.assignModel.driverID || props.assignModel.driverID == 0
                  ? props.assignModel.driverID
                  : undefined,
            };
            setProgress(true);
            AssignToDriver(model, () => props.callback());
          }}
        >
          انتقال
        </Button>
      </Box>
      <Button
        onClick={() => {
          setOpenDilog(true);
        }}
        sx={{ width: "120px" }}
        color="secondary"
        variant="contained"
      >
        یافتن هایو
      </Button>
    </Box>
  );
}
